import { Icon } from '../../r2/Icon';
import styles from './Footer.module.css';

export interface FooterLink {
  label: string;
  href: string;
}

export interface SocialLink {
  icon: string;
  href: string;
  label: string;
}

export interface FooterProps {
  navLinks?: FooterLink[];
  socialLinks?: SocialLink[];
  legalLinks?: FooterLink[];
}

const defaultNavLinks: FooterLink[] = [
  { label: 'Problem', href: '#problem' },
  { label: 'Solution', href: '#solution' },
  { label: 'About', href: '#about' },
];

const defaultSocialLinks: SocialLink[] = [
  { icon: 'facebook', href: '#', label: 'Facebook' },
  { icon: 'instagram', href: '#', label: 'Instagram' },
  { icon: 'twitter', href: '#', label: 'Twitter' },
  { icon: 'linkedin', href: '#', label: 'LinkedIn' },
  { icon: 'youtube', href: '#', label: 'YouTube' },
];

const defaultLegalLinks: FooterLink[] = [
  { label: 'Privacy Policy', href: '#' },
  { label: 'Terms of Service', href: '#' },
];

export function Footer({
  navLinks = defaultNavLinks,
  socialLinks = defaultSocialLinks,
  legalLinks = defaultLegalLinks,
}: FooterProps) {
  const year = new Date().getFullYear();

  return (
    <footer data-crd-id="r3.bq-footer" data-crd-layer="r3" className={styles.footer}>
      <div className={styles.container}>
        <nav className={styles.nav}>
          {navLinks.map((link) => (
            <a key={link.href} href={link.href} className={styles.navLink}>
              {link.label}
            </a>
          ))}
        </nav>

        <div className={styles.divider} />

        <div className={styles.bottom}>
          <div className={styles.copyright}>
            &copy; {year} BlueQueue LLC. All rights reserved.
          </div>
          <div className={styles.legal}>
            {legalLinks.map((link) => (
              <a key={link.label} href={link.href} className={styles.legalLink}>
                {link.label}
              </a>
            ))}
          </div>
          <div className={styles.social}>
            {socialLinks.map((link) => (
              <a
                key={link.icon}
                href={link.href}
                className={styles.socialLink}
                aria-label={link.label}
              >
                <Icon name={link.icon} size="md" color="n000" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
